export default __webpack_public_path__ + "static/media/MicrosoftTeamsimage.1b66de90.png";